import { LngLat } from '@yandex/ymaps3-types';

export const RUSSIA = 'Россия';
export const MOSCOW_COORDS: LngLat = [37.57, 55.75];
export const DEFAULT_LOCATION = {
	center: MOSCOW_COORDS,
	zoom: 8,
};
export const DEFAULT_ZOOM_RANGE = { min: 3, max: 20 };
